import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

function parseQuery(search: string): Record<string, string> {
  const params = new URLSearchParams(search);
  const obj: Record<string, string> = {};
  params.forEach((value, key) => {
    obj[key] = value;
  });
  return obj;
}

function stringifyQuery(params: Record<string, string | undefined>): string {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      sp.set(key, value);
    }
  });
  return sp.toString();
}

export function useQueryParams<T extends Record<string, string | undefined>>() {
  const location = useLocation();
  const history = useHistory();

  const query = parseQuery(location.search) as T;

  const setQuery = useCallback(
    (newParams: Partial<T>, replace = false) => {
      const merged = { ...query, ...newParams };
      const search = stringifyQuery(merged);
      const newUrl = `${location.pathname}?${search}`;

      if (replace) {
        history.replace(newUrl);
      } else {
        history.push(newUrl);
      }
    },
    [query, location.pathname, history],
  );

  return [query, setQuery] as const;
}
